// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__tlYsM","wrapper__input":"Editable_wrapper__input__8pjie"};